/* eslint-disable react-hooks/exhaustive-deps */
import styled from 'styled-components'
import {useAppSelector} from '../../../../redux/hooks'
import {appSelector} from '../../../../redux/slices/appSlices'
import {useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import moment from 'moment'
import i18next from 'i18next'

const StyledOrderInfo = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`

const StyledProperty = styled.div`
  padding: 0 0.75rem;
  min-width: 60px;
  border-right: 1px dashed #dcdcdc;

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    border-right: none;
  }
`

export const OrderInfo = () => {
  const {t} = useTranslation()
  const {orderDetail: order} = useAppSelector(appSelector)

  const regarding = useMemo(() => {
    if (!order?.perihal) return '-'
    return order.perihal === 'PO001' ? t('penjualan') : t('Non-penjualan')
  }, [])

  const colorStatus = useMemo(() => {
    switch (order?.status) {
      case 0:
      case 4:
      case 5:
        return 'badge badge-light-success'
      case 1:
      case 3:
        return 'badge badge-light-primary'
      case 2:
      case 7:
        return 'badge badge-light-warning'
      case 9:
      case 6:
        return 'badge badge-light-info'
      case 99:
        return 'badge badge-light-danger'
      default:
        return 'text-black'
    }
  }, [])

  const regardingColor = useMemo(() => {
    if (!order?.perihal) return ''
    if (order.perihal === 'PO001') return 'badge badge-light-success'
    return 'badge badge-light-primary'
  }, [])

  return (
    <StyledOrderInfo>
      <Property label='Status' value={order?.status_text ?? '-'} textColor={colorStatus} />
      <Property label={t('order-perihal')} value={regarding} textColor={regardingColor} />
      <Property
        label={`${t('sip-pengajuan')} ${t('Order')}`}
        value={`10${order?.pengajuan_order?.po_number}` ?? '-'}
      />
      <Property label={t('Customer Name')} value={order?.customer?.name ?? '-'} />
      <Property
        label={t('Tanggal Pengajuan SIP')}
        value={
          moment(new Date(order?.estimate_date as string))
            .lang(i18next.language)
            .format('DD MMMM YYYY') ?? '-'
        }
      />
    </StyledOrderInfo>
  )
}

export const Property = (props: {label: string; value: string | number; textColor?: string}) => {
  const {label, value, textColor} = props
  return (
    <StyledProperty>
      <div style={{color: '#535353', marginBottom: '.25rem'}}>{label}</div>
      <h6 className={textColor}>{value}</h6>
    </StyledProperty>
  )
}
